import * as React from 'react';
import { Rect } from '../types';

interface ClickableAreaProps {
  rect: Rect;
  scale: number;
  translateY: number;
  translateX: number;
  onClick: () => void;
  title?: string;
}

const ClickableArea: React.SFC<ClickableAreaProps> = (props) => {
  const { rect, scale, translateX, translateY, title, onClick } = props;
  const { x, y, width, height } = rect;
  const style: React.CSSProperties = {
    display: 'block',
    position: 'absolute',
    top: `${y * scale + translateY}px`,
    left: `${x * scale + translateX}px`,
    width: `${width}px`,
    height: `${height}px`,
    transformOrigin: 'left top',
    transform: `scale(${scale})`,
    background: 'transparent',
    cursor: 'pointer',
  };

  return <a
    title={title}
    style={style}
    onClick={onClick}
  />;
};

export default ClickableArea;
